import './style.scss';
import Datepicker from './datepicker.js';

export default Datepicker;